var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cancel-close-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "J-Story_HP-desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JStory_Create_Experience",
    transform: "translate(-1737.000000, -41.000000)",
    fill: "#717C9C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1739.86921,41.4922784 L1747,48.623 L1754.13079,41.4922784 C1754.78716,40.8359072 1755.85135,40.8359072 1756.50772,41.4922784 C1757.16409,42.1486496 1757.16409,43.2128376 1756.50772,43.8692088 L1749.377,51 L1756.50772,58.1307912 C1757.16409,58.7871624 1757.16409,59.8513504 1756.50772,60.5077216 C1755.85135,61.1640928 1754.78716,61.1640928 1754.13079,60.5077216 L1747,53.377 L1739.86921,60.5077216 C1739.21284,61.1640928 1738.14865,61.1640928 1737.49228,60.5077216 C1736.83591,59.8513504 1736.83591,58.7871624 1737.49228,58.1307912 L1744.623,51 L1737.49228,43.8692088 C1736.83591,43.2128376 1736.83591,42.1486496 1737.49228,41.4922784 C1738.14865,40.8359072 1739.21284,40.8359072 1739.86921,41.4922784 Z",
    id: "cancel-close-icon"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.11ac3357.svg";
export { ForwardRef as ReactComponent };